import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ng2-cookies';

@Injectable({
  providedIn: 'root',
})
export class SecurityService {
  constructor(private cookie: CookieService, private router: Router) {}

  private token: string = '';

  private user: any;

  private groupUser: any;

  private username: string = '';

  private sessionLogin: string = '';

  private loBoFilter: string = '';

  public getToken() {
    return this.cookie.get('idToken');
  }

  public setToken(token: string) {
    try {
      const payloadEncoded = token.split('.')[1];
      const payloadDecoded = atob(payloadEncoded);
      const payload = JSON.parse(payloadDecoded);
      if (payload && payload.exp) {
        const expDate = new Date(payload.exp * 1000);
        this.cookie.set('idToken', token, expDate,'/');
      } else {
        const now = new Date();
        const fallbackExp = new Date(now.getFullYear() + 1, now.getMonth(), now.getDate());
        this.cookie.set('idToken', token, fallbackExp,'/');
      }
    } catch (error) {
      const now = new Date();
      const fallbackExp = new Date(now.getFullYear() + 1, now.getMonth(), now.getDate());
      this.cookie.set('idToken', token, fallbackExp,'/');
    }
    this.token = token;
  }
  public setUser(user: any) {
    this.user = this.cookie.set('user', user.username);
    this.user = user;
  }

  public getUser() {
    return this.cookie.get('user');
  }

  public setGroupUser(user: any) {
    let gruppo = '';
    if (
      user &&
      user.userGroups &&
      user.userGroups.length > 0 &&
      user.singleGroupUserFe
    ) {
      gruppo = user.singleGroupUserFe;
    }
    this.cookie.set('groupUser', gruppo);
    this.groupUser = gruppo;
  }

  public getGroupUser() {
    return this.cookie.get('groupUser');
  }

  public isLoggedIn(): boolean {
    return this.isTokenValid();
  }

  public isUserAdmin(): boolean {
    if (this.getGroupUser() && this.getGroupUser() == 'ADMIN_FREEMOVE_FE') {
      return true;
    } else {
      return false;
    }
  }

  public setUsername(username: string) {
    this.cookie.set('username', username);

    this.username = username;
  }

  public getUsername() {
    return this.cookie.get('username');
  }

  public setSessionLogin(sessionLogin: string) {
    this.cookie.set('sessionLogin', sessionLogin);

    this.sessionLogin = sessionLogin;
  }

  public getSessionLogin() {
    return this.cookie.get('sessionLogin');
  }

  public isSimpleUser(): boolean {
    if (this.getGroupUser() && this.getGroupUser() == 'USER_FREEMOVE_FE') {
      return true;
    } else {
      return false;
    }
  }

  public setLoBoFilter(loBoFilter: string) {
    this.cookie.set('loBoFilter', loBoFilter);
    this.loBoFilter = loBoFilter;
  }

  public getLoBoFilter() {
    return this.cookie.get('loBoFilter');
  }
  
  public isTokenValid(): boolean {
    const token = this.getToken();
    if (!token) {
      return false;
    }
    try {
      const payloadEncoded = token.split('.')[1];
      const payloadDecoded = atob(payloadEncoded);
      const payload = JSON.parse(payloadDecoded);
      if (payload && payload.exp) {
        const nowInSec = Math.floor(Date.now() / 1000);
        return nowInSec < payload.exp;
      }
      return false;
    } catch (error) {
      return false;
    }
  }
  
  public logout(): void {
    this.cookie.delete('idToken');
    this.cookie.delete('groupUser');
    this.cookie.delete('user');
    this.cookie.delete('username');
    this.cookie.delete('loBoFilter');
    this.cookie.delete('sessionLogin');
    localStorage.removeItem('loBoFilter');
    localStorage.removeItem('user');
     this.router.navigate(['/login']).then(() => {
    window.location.reload();
  });
  }
}
